import React, { useState, useContext } from 'react';
import {
  AccordionGroup,
} from 'anf-core-react';
import SizeAndFitAccordion from './SizeAndFitAccordion/SizeAndFitAccordion';
import DetailsAccordion from './DetailsAccordion/DetailsAccordion';
import ShippingAndReturnsAccordion from './ShippingAndReturnsAccordion/ShippingAndReturnsAccordion';
import ProductPageContext from '../../contexts/ProductPageContext';
import ESpotContent from '../../components/ESpotContent/ESpotContent';
import MeasurementsAccordion from './SizeAndFitAccordion/MeasurementsAccordion';

// TODO: remove event listeners once we have swatches in MFE
export default function BuyGridAccordionWrapper({
  categoryId, reviewData, shippingContent, siteRegion,
}) {
  const ProductPageState = useContext(ProductPageContext);

  const {
    tmntData,
    collectionData,
    content,
  } = ProductPageState;

  const {
    activeProduct,
  } = collectionData;

  const [activeAccordion, setActiveAccordion] = useState(0);

  const accordionAnalytics = (text) => {
    window.digitalData.trigger('analytics.pdp_accordion_open', {
      tealium_event: 'click',
      data_text: text,
      data_action: 'open',
    });
  };

  const exclusiveToggle = (accordionIdentifier) => () => {
    if (accordionIdentifier !== activeAccordion) {
      accordionAnalytics(accordionIdentifier);
      setActiveAccordion(accordionIdentifier);
    } else {
      setActiveAccordion(0);
    }
  };

  return (
    <div className="buy-grid-accordion-group-container_mfe" data-testid="buy-grid-accordion-group-container_mfe" data-product-brand={activeProduct.brand}>
      <ESpotContent eSpotData={content?.pdpESpots?.pdp_aboveaccordion} />
      <AccordionGroup>
        {collectionData.isEyewearProduct && (
        <MeasurementsAccordion
          onClick={exclusiveToggle}
          activeAccordion={activeAccordion}
          tmntData={tmntData}
          isEyewearProduct={collectionData?.isEyewearProduct}
          activeProduct={activeProduct}
        />
        )}
        {!collectionData.isEyewearProduct && (
        <SizeAndFitAccordion
          activeProduct={activeProduct}
          onClick={exclusiveToggle}
          activeAccordion={activeAccordion}
          categoryId={categoryId}
          tmntData={tmntData}
          reviewData={reviewData}
          eSpotContent={content?.pdpESpots}
        />
        )}
        <DetailsAccordion
          activeProduct={activeProduct}
          onClick={exclusiveToggle}
          activeAccordion={activeAccordion}
          tmntData={tmntData}
          siteRegion={siteRegion}
          eSpotContent={content?.pdpESpots}
          isEyewearProduct={collectionData?.isEyewearProduct}
        />
        <ShippingAndReturnsAccordion
          onClick={exclusiveToggle}
          activeAccordion={activeAccordion}
          shippingContent={shippingContent}
          tmntData={tmntData}
          siteRegion={siteRegion}
        />
      </AccordionGroup>
    </div>
  );
}
